import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AlertandloadingService } from "src/app/services/alertandloading.service";
import { ApiService } from "src/app/services/api.service";

@Component({
  selector: "app-confirm-staking",
  templateUrl: "./confirm-staking.page.html",
  styleUrls: ["./confirm-staking.page.scss"],
})
export class ConfirmStakingPage implements OnInit {
  transactionPassword: string;
  wallet: any;
  amount: number;
  fromFiat: boolean;
  to_address: string;

  activeView: string = "send";
  transactionInfo: any;

  passInputConfig = {
    length: 4,
    inputClass: "otp-input-item",
    containerClass: "otp-input-holder",
    inputStyles: {
      width: "35px",
      height: "35px",
    },
    allowNumbersOnly: true,
  };

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private alertandLoading: AlertandloadingService,
    public api: ApiService
  ) {
    this.wallet = this.navParams.get("wallet");
    this.amount = this.navParams.get("amount");
    this.fromFiat = this.navParams.get("fromFiat");
    this.to_address = this.navParams.get("to_address");
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(this.transactionInfo);
  }

  txnPasswordChanged(event: any) {
    this.transactionPassword = event;
  }

  async submit() {
    if (
      this.transactionPassword !== undefined &&
      this.transactionPassword.length == 4
    ) {
      let data = {
        txn_password: this.transactionPassword,
        from_wallet_id: this.wallet.wallet_id,
        is_from_fiat: this.fromFiat ? 1 : 0,
        amount: this.amount,
        staking_address: this.to_address,
      };

      this.alertandLoading.presentLoading("sending transaction please wait");

      this.api.addV2Staking(data).then(
        (result: any) => {
          this.alertandLoading.dismissLoading();
          if (!result.error) {
            this.transactionInfo = result.data.transaction;
            this.activeView = "result";
          } else {
            this.alertandLoading.showAlert(
              "Alert",
              "Oops something went wront try again"
            );
          }
        },
        (error: any) => {
          this.alertandLoading.dismissLoading();
          //console.log(error);
        }
      );
    } else {
      this.alertandLoading.showAlert(
        "Alert",
        "Please enter a valid 4 digit transaction password"
      );
    }
  }
}
